import { Component, OnInit } from '@angular/core';

import { CityInfo } from '../../models/city-info.model';
import { CityInfoService } from '../../services/city-info.service';

@Component({
  selector: 'app-vacantbedreference',
  templateUrl: './vacant-bed-reference.component.html',
  styleUrls: ['./vacant-bed-reference.component.css']
})
export class VacantBedReferenceComponent implements OnInit {

  cityInfoes: CityInfo[];

  constructor(private cityInfoService: CityInfoService) { }

  ngOnInit() {
    this.cityInfoService.getCityInfoes().subscribe(infoes => this.cityInfoes = infoes);
  }
}
